import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import React from 'react';
import { SxProps, Theme } from '@mui/material/styles';
import { useTranslate } from '@im/react-localization';

type CoookiesContentProps = {
  height?: string | number;
  sx?: SxProps<Theme>;
  width?: string | number;
};

export function CookiesConsent(props: CoookiesContentProps) {
  const { height, sx, width } = props;
  const translate = useTranslate();
  const handleClickOpen = () => {
    (window as any)?.OneTrust.ToggleInfoDisplay();
  };
  return (
    <Box
      sx={{
        backgroundColor: '#F8F8F8',
        display: 'grid',
        height: height,
        justifyContent: 'center',
        width: width,
        ...sx,
      }}
    >
      <Stack
        sx={{
          alignItems: 'center',
          alignSelf: 'center',
          color: '#6B6B6B',
          fontFamily: 'Roboto',
          lineHeight: '22px',
          width: '232px',
        }}
      >
        <Box sx={{ height: '70px' }}>
          <Button
            sx={{
              alignItems: 'center',
              background: '#D92D20',
              borderRadius: '32px',
              boxShadow: '0px 1px 2px 0px rgba(18, 25, 38, 0.05)',
              display: 'inline-flex',
              gap: '8px',
              height: '56px',
              justifyContent: 'center',
              minWidth: '56px',
              padding: '16px',
              pointerEvents: 'none',
            }}
          >
            <svg
              fill="none"
              height="24"
              viewBox="0 0 24 24"
              width="24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.49 22.0025H4.04004C2.95004 22.0025 2.35004 22.0025 1.82004 21.6225C1.36004 21.2925 1.07004 20.7725 1.01004 20.2125C0.940036 19.5625 1.24004 19.0425 1.79004 18.1025L10.01 3.8925L10.88 4.3925L10.02 3.8925C10.56 2.9525 10.86 2.4325 11.46 2.1725C11.98 1.9425 12.57 1.9425 13.08 2.1725C13.67 2.4325 13.97 2.9525 14.52 3.8925L22.75 18.1025C23.3 19.0525 23.6 19.5625 23.53 20.2125C23.47 20.7725 23.18 21.2925 22.72 21.6225C22.19 22.0025 21.59 22.0025 20.5 22.0025H20.49ZM3.04004 19.9825C3.25004 20.0025 3.65004 20.0025 4.04004 20.0025H20.49C20.88 20.0025 21.28 20.0025 21.49 19.9825C21.4 19.7925 21.21 19.4425 21.01 19.1125L12.78 4.9025C12.58 4.5625 12.38 4.2225 12.26 4.0525C12.14 4.2225 11.94 4.5625 11.74 4.9025L3.52004 19.1025C3.32004 19.4425 3.12004 19.7925 3.04004 19.9825ZM12.28 18.5025C11.73 18.5025 11.28 18.0525 11.28 17.5025C11.28 16.9525 11.72 16.5025 12.28 16.5025C12.83 16.5025 13.28 16.9525 13.28 17.5025C13.28 18.0525 12.83 18.5025 12.28 18.5025ZM12.28 14.5025C11.73 14.5025 11.28 14.0525 11.28 13.5025V9.5025C11.28 8.9525 11.73 8.5025 12.28 8.5025C12.83 8.5025 13.28 8.9525 13.28 9.5025V13.5025C13.28 14.0525 12.83 14.5025 12.28 14.5025Z"
                fill="white"
              />
            </svg>
          </Button>
        </Box>
        <Stack direction="row" sx={{ height: '32px' }}>
          <Box
            sx={{
              color: '#6B6B6B !important',
              display: 'inline',
              fontSize: '16px',
              fontWeight: '400',

              lineHeight: '22px',
            }}
          >
            {translate('Cms.ConsentMsg')}{' '}
            <Typography
              onClick={handleClickOpen}
              sx={{
                color: '#6B6B6B !important',
                cursor: 'pointer',
                display: 'inline',
                fontSize: '16px',
                fontWeight: '400',
                lineHeight: '22px',
                textDecorationLine: 'underline',
              }}
            >
              {translate('Cms.ConsentClick')}
              {''}
            </Typography>{' '}
            {translate('Cms.cookieConsentMsg')}
          </Box>
        </Stack>
      </Stack>
    </Box>
  );
}
